import * as LDClient from 'launchdarkly-js-client-sdk'
import { camelCase } from 'lodash'

const formatFlags = (flags) => {
  return Object.fromEntries(
    Object.keys(flags).map((key) => {
      return [camelCase(key), flags[key]]
    })
  )
}

export default (context, inject) => {
  const { store, $config } = context
  const trackingEnabled = $config.env === 'production'
  const clientSideId = '60b0a961d674700e13aba8e6'

  const ldClient = LDClient.initialize(
    clientSideId,
    store.getters['store/email'] ? { key: store.getters['store/email'] } : { anonymous: true },
    { bootstrap: 'localStorage' }
  )

  const ld = {
    ldClient,
    identify ({ newUser, hash, callback }, vueLdCallback) {
      return new Promise((resolve) => {
        store.commit('ld/SET_READY_STATE', false)
        ldClient.identify(newUser, hash, callback).then(() => {
          store.commit('ld/SET_READY_STATE', true)
          if (vueLdCallback) {
            const boundVueLdCallback = vueLdCallback.bind(ld)
            boundVueLdCallback()
          }
          resolve()
        })
      })
    },
    track (eventName, eventProperties = null, eventValue = null) {
      if (!trackingEnabled) return
      return ldClient.track(eventName, eventProperties, eventValue)
    },
    isFlagActive (flag) {
      return !!store.getters['ld/flags'][flag]
    }
  }

  ldClient.on('ready', () => {
    store.commit('ld/SET_FLAGS', formatFlags(ldClient.allFlags()))
    store.commit('ld/SET_READY_STATE', true)
  })

  ldClient.on('change', (changes) => {
    const flattenedFlags = Object.fromEntries(
      Object.keys(changes).map(key => [key, changes[key].current])
    )
    store.commit('ld/SET_FLAGS', {
      ...ld.flags,
      ...formatFlags(flattenedFlags)
    })
  })

  inject('ld', ld)
}